export namespace AppActions {

  export class StartupAfterLogin {
    static readonly type = getActionName('Startup after Login');

    /**
     * @param isNewLogin true if user just logged in, false if we are reloading the page after a login check
     * @constructor
     */
    constructor(readonly isNewLogin: boolean) { }
  }

  export class RestoreAuthState {
    static readonly type = getActionName('Restore Auth State');
  }

  export class LoadInitialData {
    static readonly type = getActionName('Load Initial Data');
  }

  function getActionName(type: string) {
    return `[App] ${type}`;
  }
}
